<template>
  <div class="mt-5">
    <vs-tabs>
      <vs-tab label="Mes informations">
        <div>
          Mes informations
          <info></info>
        </div>
      </vs-tab>
      <!--<vs-tab label="Activité">
        <div>
         Les derniers sujets sur le forum
          <activity></activity>
        </div>
      </vs-tab>-->
      <vs-tab label="Paramètres">
        <div>
          
          <password222></password222>
        </div>
      </vs-tab>
      
    </vs-tabs>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/4 w-full">
        
      </div>
      <div class="vx-col sm:w-1/4 w-full">
        
      </div>
      <div class="vx-col sm:w-1/4 w-full">
        
      </div>
      <div class="vx-col sm:w-1/4 w-full">
        
      </div>
    </div>
  </div>
  </template>

<script>


import password222 from '../password/edit.vue'
import activity from '../Activity/principal.vue'
import info from './Infos/principal.vue'

export default {
  components: {
    activity,
    info,
    password222
  }
}
</script>


  